import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, FormControlLabel, FormGroup, Grid, IconButton, Paper, Switch, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { fetchOrgRequest } from '../../../api/organizations/orgSlice';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { useMutateNotificationToBuyerOnDocumentApprovalHandler } from './mutateNotificationToBuyerOnDocumentApprovalHandler';

const NotificationToBuyerOnDocumentApprovalSettingSection = () => {
  const dispatch = useDispatch();

  const { settings } = useSelector((state) => state.org.org);
  const { settings: msg } = useTranslatedMessages();

  const notificationSettings = settings?.notification_settings;

  const [checked, setChecked] = useState(notificationSettings?.sendNotificationToBuyerOnDocumentApproval ?? false);

  useEffect(() => {
    setChecked(notificationSettings?.sendNotificationToBuyerOnDocumentApproval ?? false);
  }, [notificationSettings?.sendNotificationToBuyerOnDocumentApproval]);

  const { onSubmit, isPending } = useMutateNotificationToBuyerOnDocumentApprovalHandler({
    onSuccess: () => {
      dispatch(fetchOrgRequest());
    },

    onError: () => {
      setChecked((currentValue) => !currentValue);

      dispatch(
        showSnackbar({
          message: 'Failed to update notification settings. Please try again.',
          severity: 'error',
        }),
      );
    },
  });

  const handleChange = () => {
    const updatedValue = !checked;

    setChecked(updatedValue);

    onSubmit({
      sendNotificationToBuyerOnDocumentApproval: updatedValue,
    });
  };

  return (
    <Paper elevation={0} sx={{ pl: '1rem' }}>
      <Grid container>
        <Grid size={6}>
          <FormGroup row>
            <FormControlLabel
              control={<Switch checked={checked} disabled={isPending} onChange={handleChange} />}
              label={
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  {msg.send_notification_to_buyer_on_document_approval.label}

                  <Tooltip title={msg.send_notification_to_buyer_on_document_approval.tooltip}>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{
                ml: 0,
                justifyContent: 'space-between',
                width: '100%',
              }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default NotificationToBuyerOnDocumentApprovalSettingSection;
